<!--
Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

@switch (data.elementType) {
    @case (leadElementType.Icon) {
        <div class="lead-offset lead-icon-container">
            <mat-icon class="lead-icon" [svgIcon]="data.icon"></mat-icon>
        </div>
    }
    @case (leadElementType.AvatarIcon) {
        <div class="lead-offset lead-avatar-container">
            <div class="lead-avatar-box">
                <img class="lead-avatar-icon" [src]="data.primaryIcon" alt="" role="presentation" />
                @if (data.badgeIcon) {
                    <img class="lead-avatar-badge" [src]="data.badgeIcon" alt="" role="presentation" />
                }
            </div>
        </div>
    }
    @case (leadElementType.SquareImage) {
        <div class="lead-offset lead-square-image-container">
            <img class="lead-square-image" [src]="data.image" alt="" role="presentation" />
        </div>
    }
    @case (leadElementType.RectangularImage) {
        <div class="lead-rectangular-image-container">
            <img class="lead-rectangular-image" [src]="data.image" alt="" role="presentation" />
        </div>
    }
}
